<template>
  <HModal
    :visible="visible"
    :show-close="false"
  >
    <span
      class="
        close-box
        sprite-lifelong-vip-discount sprite-lifelong-vip-discount-close
      "
      @click="clickClose"
    />

    <div class="wrapper-box">
      <div
        v-if="activityName"
        class="activity-name"
      >
        {{ activityName }}
      </div>
      <h2
        v-if="title"
        class="title"
      >
        {{ title }}
      </h2>
      <h3
        v-if="content"
        class="content"
      >
        {{ content }}
      </h3>
      <button
        class="enter"
        @click="clickEnter"
      >
        {{ buttonText }}
      </button>
    </div>
  </HModal>
</template>

<script>
import { PopupController, PopupEvent, PopupInsEnum } from '@/services/act/PopupController'
import clientApi from '@/client'
import { DOMAIN_RELATED } from '@/config/dataMap'
import client from '@/client/'

let retainUsers = null
export default {
  name: 'RetainUsers',
  components: {},
  props: {},
  data () {
    return {
      visible: false,
      textConfig: {},
    }
  },
  computed: {
    isTextConfig () {
      const arr = Object.keys(this.textConfig)
      return arr.length === 0
    },

    activityName () {
      return this.textConfig.activityName || ''
    },

    title () {
      return this.textConfig.title || ''
    },

    content () {
      return this.textConfig.content || ''
    },

    buttonText () {
      return this.textConfig.buttonText || ''
    },
  },

  mounted () {
    this.init()
  },
  methods: {
    init () {
      retainUsers = PopupController.getIns().getControllerIns(PopupInsEnum.retainUsers)

      this.$EventBus.$on(PopupEvent.retainUsersEvent, () => {
        if (this.isTextConfig) {
          this.getConfig()
        }

        this.open()
        PopupController.getIns().setPopUpCache(PopupInsEnum.retainUsers)
      })
    },

    async getConfig () {
      const config = await retainUsers.getActivityConfig()
      if (!config) {
        // 没有配置关闭
        this.clickClose()
        return
      }

      this.textConfig = config
    },

    clickClose () {
      this.report({ clicked: 2 })
      this.close()
      window.close()
    },

    clickEnter () {
      this.close()
      this.report({ clicked: 4 })
      clientApi.common.API.client_openOptionWindow({
        url: `${DOMAIN_RELATED.domain}${DOMAIN_RELATED.channel}/activity/retainuserpay`,
        width: 600,
        height: 420,
        open_opction: 19,
      })
    },

    close () {
      this.visible = false
    },

    open () {
      this.visible = true
      this.report({ showed: 2 })
    },

    report ({ showed = 0, clicked = 0 }) {
      client.retainUsers.REPORT.reportQuitRetainUsers({ showed, clicked })
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/css/sprite-lifelong-vip-discount.scss';
::v-deep .h-modal__content {
  background: transparent;
  box-shadow: none;
}
.close-box {
  position: absolute;
  position: absolute;
  top: -6px;
  right: 60px;
  transform: scale(0.9);
  cursor: pointer;
  z-index: 1;
}

.wrapper-box {
  height: 439px;
  width: 565px;
  background: url(~@/assets/images/retain-bg.png) no-repeat;
  background-size: cover;
  position: relative;
  .activity-name,
  .title,
  .content {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    text-align: center;
    font-weight: bold;
    color: #ffffff;
  }
  .activity-name {
    font-size: 24px;
    font-weight: 400;
    top: 45px;
  }
  .title {
    font-size: 36px;
    font-weight: bold;
    top: 95px;
  }
  .content {
    font-size: 28px;
    font-weight: bold;
    top: 147px;
  }
  .enter {
    cursor: pointer;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    bottom: 58px;
    width: 300px;
    height: 70px;
    background-color: transparent;
    background: url(~@/assets/images/retain-btn.png) no-repeat;
    outline: none;
    border: none;
    font-size: 26px;
    font-weight: bold;
    color: #e6384d;
  }
}
</style>
